@if (initialized && activeNavigationItem) {
    <div class="config-content-container surface-0">

        @if (activeNavigationItem?.action === 'dc.DcPageType') {
            <div class="grid h-full m-0">
                <div class="col-12 md:col-4 lg:col-3 h-full p-2 pt-0 scroll-sidebar-container">
                    @if (widgets?.widgetDcPageType) {
                        <mvs-widget
                                [widgetData]="widgets?.widgetDcPageType.widgetData"
                                (onObjectSelect)="onDcPageTypeSelect($event)"
                                (onObjectDeselect)="onDcPageTypeDeselect()">
                        </mvs-widget>
                    }
                </div>
                <div class="col-12 md:col-8 lg:col-9 h-full p-2 pt-0 scroll-table-container">
                    <p-tabs [(value)]="dcPageTypeInnerTabIndex">
                        <p-tablist>
                            <p-tab [value]="0"><i class="fa-regular fa-file-lines mr-2"></i>Seiten</p-tab>
                            <p-tab [value]="1"><i class="fa-regular fa-layer-group mr-2"></i>Abschnitte</p-tab>
                        </p-tablist>
                        <p-tabpanels>
                            <p-tabpanel [value]="0">
                                @if (dcPageChildWidget) {
                                    <mvs-widget [widgetData]="dcPageChildWidget"
                                                (onObjectSelect)="handleEntitySelect($event)"></mvs-widget>
                                }
                            </p-tabpanel>
                            <p-tabpanel [value]="1">
                                @if (dcPageTypeSectionChildWidget) {
                                    <mvs-widget [widgetData]="dcPageTypeSectionChildWidget"
                                                (onObjectSelect)="handleEntitySelect($event)"></mvs-widget>
                                }
                            </p-tabpanel>
                        </p-tabpanels>
                    </p-tabs>
                </div>
            </div>
        }

        @if (activeNavigationItem?.action === 'dc.DcPage') {
            <div class="h-full p-2 pt-0 scroll-table-container">
                @if (widgets?.widgetDcPage) {
                    <mvs-widget
                            [widgetData]="widgets?.widgetDcPage.widgetData"
                            (onObjectSelect)="handleEntitySelect($event)">
                    </mvs-widget>
                }
            </div>
        }

    </div>
}
